module.exports = __webpack_public_path__ + "img/Monte_Kope_106.a21a98ff.jpg";